export default "__VITE_ASSET__CqWHbRsp__"